<template>
  <div class="hawkEyeOfParkList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="pageSize" value="0" @change="changeSize()" v-if="hidepage && tableData.length > 0">
            <el-option v-for="(item,index) in $t('lang.SIZELIST.LIST')" :key="index" :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="chooseOne" class="wid-280" :value="0" @change="chooseVideo()">
            <el-option key :label="$t('lang.lab_chooseVideo')" :value="0" v-if="tableData.length > 0"></el-option>
            <el-option key :label="$t('lang.lab_noEye')" :value='0' v-if="tableData.length === 0"></el-option>
            <el-option v-for="(item,index) in allData" :key="index" :label="item.monitorPositionName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="chooseType" :value="0" @change="changeTypes()" v-if="hidepage && tableData.length > 0">
            <el-option key :label="$t('lang.lab_chooseType')" :value="0" v-if="tableData.length > 0"></el-option>
            <el-option v-for="(item,index) in allTypes" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-card v-if="tableData.length > 0">
      <el-button type="primary" slot="header" @click="startCrop()">{{$t('lang.lab_cutImg')}}</el-button>
      <el-button type="primary" slot="header" @click="jump()">{{$t('lang.lab_jump')}}</el-button>
      <div class="img-box" ref="imageWrapper">
        <el-card v-for="(item, index) in tableData" :key="index" class="video">
          <video autoplay controls playsInline webkit-playsinline :width="changeFour" :id="'video' + item.id">
            <source :src="item.videoURL">
          </video>
          <div>{{item.monitorPositionName}}</div>
        </el-card>
      </div>
      <el-pagination v-if="tableData.length > 0 && hidepage" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="[4, 9]" :page-size="pageSize" layout="prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:hawkEyeOfParkList
   *@Description:园区鹰眼 监控
   *@author:刘彦辰
   *@Copyright:格众科技
   *@date:2020-05-8
   */
  import html2canvas from 'html2canvas'
  import '../../../config/ezuikit.js'
  import { mapGetters } from 'vuex'

  // import '../../../config/niuniucapture.js'
  // import '../../../config/capturewrapper.js'
  export default {
    name: '/manage/main.supplyVideoByType',
    data() {
      return {
        imgUrl: '',
        changeFour: 0, // 判断四宫格还是九宫格
        videoSizeList: [], // 储存页码
        allData: [], // 全部视频的url
        allTypes: [], // 全部分类
        tableData: [], // 存储视频url的数组
        pageNo: 1, // 页数
        pageSize: 4, // 每页显示数量
        pageCount: 0, // 总页数
        chooseOne: 0, // 单个鹰眼位置的url
        chooseType: 0, // 鹰眼分类
        hidepage: true, // 是否隐藏四宫格
        allVideo: [], // 所有下拉列表
        allVideoId: '', // 临时的视频存放
        screenWidth: '',
      }
    },
    created() {
      // 许 this.getVideo()
      this.getAllVideo()
      this.getVideoType(this.chooseType)
      this.getTypes()
    },
    mounted() {
      const that = this
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    watch: {
      gardenId: function (newFlag, oldFlag) {
        // 许 this.getVideo()
        this.getVideoType(this.chooseType)
        this.chooseVideo()
      },
      screenWidth(val) {
       // 许 this.getVideo()
       this.getVideoType(this.chooseType)
      }
    },
    methods: {
      // 获取鹰眼全部分类
      getTypes() {
        let loading = this.$loading()
        this.$get(`/getVideoMonitorTypes`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.allTypes = res.result
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取全部鹰眼位置
      getAllVideo() {
        let loading = this.$loading()
        this.$get(`/getVideoMonitorInterfaceByVideoMonitorType?gardenId=${this.gardenId}&pageSize=99999&pageNo=1`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.allData = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },

      getVideoType(type) {
        let loading = this.$loading()
        let width = document.body.clientWidth
        if (this.pageSize === 4) {
          this.changeFour = (width - 220 - 70 - 41 * 4) * 0.37
        } else {
          this.changeFour = (width - 220 - 70 - 41 * 6) * 0.30
        }
        this.$get(
          `/getVideoMonitorInterfaceByVideoMonitorType?Id=` + type + `&pageSize=${this.pageSize}&pageNo=${this.pageNo}`
          ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.allVideo = []
              for (let index = 0; index < res.list.length; index++) {
                this.allVideo.push(res.list[index].id)
              }
              this.pageCount = res.pageCount
              this.chooseType = type
              this.getTypes()
              setTimeout(() => {
                for (var i = 0; i < this.allVideo.length; i++) {
                  // eslint-disable-next-line no-undef
                  this.allVideo[i] = new EZUIKit1.EZUIPlayer('video' + this.tableData[i].id)
                }
              }, 1000)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },

      // 获取鹰眼列表
      // getVideo() {
      //   let loading = this.$loading()
      //   let width = document.body.clientWidth
      //   if (this.pageSize === 4) {
      //     this.changeFour = (width - 220 - 70 - 41 * 4) * 0.37
      //   } else {
      //     this.changeFour = (width - 220 - 70 - 41 * 6) * 0.30
      //   }
      //   this.$get(
      //     `/getVideoMonitorInterfaceByVideoMonitorType?gardenId=${this.gardenId}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`
      //     ).then(res => {
      //       loading.close()
      //       if (res && res.errCode === 0) {
      //         this.tableData = res.list
      //         this.allVideo = []
      //         for (let index = 0; index < res.list.length; index++) {
      //           this.allVideo.push(res.list[index].id)
      //         }
      //         this.pageCount = res.pageCount
      //         setTimeout(() => {
      //           for (var i = 0; i < this.allVideo.length; i++) {
      //             // eslint-disable-next-line no-undef
      //             this.allVideo[i] = new EZUIKit.EZUIPlayer('video' + this.tableData[i].id)
      //           }
      //         }, 1000)
      //       }
      //     },
      //     error => {
      //       loading.close()
      //       this.$message.error(error)
      //     }
      //   )
      // },
     
      // // 获取鹰眼列表
      
      // // 获取全部鹰眼列表
      // getAllVideoType(type) {
      //   let loading = this.$loading()
      //   this.$get(`/getVideoMonitorInterfaceByVideoMonitorType?Id=` + type + `&pageSize=99999&pageNo=1`).then(
      //     res => {
      //       loading.close()
      //       if (res && res.errCode === 0) {
      //         this.allData = res.list
      //       }
      //     },
      //     error => {
      //       loading.close()
      //       this.$message.error(error)
      //     }
      //   )
      // },
      
      // 选择一个鹰眼位置
      chooseVideo() {
        if (this.chooseOne === 0) {
          var redmine = this.chooseOne
          Object.assign(this.$data, this.$options.data.call(this))
          this.chooseOne = redmine
          this.getAllVideo()
          // 许  this.getVideo()
        } else {
          var redmines = this.chooseOne
          Object.assign(this.$data, this.$options.data.call(this))
          this.getAllVideo()
          this.chooseOne = redmines
          let loading = this.$loading()
          this.$get(`/getVideoMonitorInterfaceByVideoMonitorType?pageSize=99999&pageNo=1`).then(res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.allData = res.list
                this.hidepage = false
                let newVideo = []
                for (var i = 0; i < this.allData.length; i++) {
                  if (this.allData[i].id === this.chooseOne) {
                    newVideo.push(this.allData[i])
                  }
                }
                this.tableData = newVideo
                this.pageSize = 1
                this.changeFour = 1300
                setTimeout(() => {
                  // eslint-disable-next-line no-undef
                  this.allVideoId = new EZUIKit1.EZUIPlayer('video' + this.tableData[0].id)
                }, 1000)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 更改每页数量
      changeSize() {
        var pageC = this.pageSize
        Object.assign(this.$data, this.$options.data.call(this))
        this.pageSize = pageC
        this.getAllVideo()
        this.getVideoType(this.chooseType)
        // 许 this.getVideo()
      },
      // 更改鹰眼分类
      changeTypes() {
        var pageC = this.pageSize
        var p = this.chooseType
        Object.assign(this.$data, this.$options.data.call(this))
        this.pageSize = pageC
        // 许 this.getAllVideoType(p)
        this.getVideoType(p)
        this.getTypes()
      },
      jump() {
        this.$router.push({
          name: 'repoInfoBackgroundSupply'
        })
      },
      startCrop() {
        html2canvas(this.$refs.imageWrapper).then(canvas => {
          let dataURL = canvas.toDataURL('image/png')
          this.imgUrl = dataURL
          if (this.imgUrl !== '') {
            console.log('截完的图片---', this.imgUrl)
            // 下载 图片 完成
            const link = document.createElement('a')
            link.href = this.imgUrl
            link.setAttribute('download', new Date() + '.png')
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            // 做个弹框是否上传 是就跳转 否就拉倒
          }
        })
        // let loading = this.$loading()
        // this.$confirm(
        //   this.$i18n.t('lang.lab_jump_info'),
        //   this.$i18n.t('lang.lab_prompt'),
        //   {
        //     confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        //     cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        //     type: 'warning'
        //   }
        // ).then(() => {
        //   this.$router.push({ name: 'repoInfoBackgroundSupply' })
        // }).catch(() => {
        //   loading.close()
        //   this.$message({
        //     type: 'info',
        //     message: this.$i18n.t('lang.lab_del_info')
        //   })
        // })
      },
      // 点击换页
      handleCurrentChange(val) {
        var type = this.chooseType
        Object.assign(this.$data, this.$options.data.call(this))
        this.pageNo = val
        if (type == 0) {
            this.getAllVideo()
            this.getVideoType(0)
        } else {
          this.getVideoType(type)
           this.getAllVideo()
        }
        
        // 许 this.getVideo()
      },
    }
  }
</script>

<style lang="scss">
  .hawkEyeOfParkList {
    .img-box {
      img {
        width: 500px;
        height: 500px;
      }
    }

    .wid-280 {
      width: 200px;
    }

    .video {
      display: inline-block;
      margin: 30px;
    }

    .showMessage {
      text-align: center;

      .errorMessage {
        font-size: 30px;
      }
    }

    .btn-right {
      text-align: right;
      padding-right: 95px;
      margin-top: 10px;
    }

    .sel-left {
      padding-left: 30px;
      margin-top: 10px;
    }
  }
</style>